import 'vanilla-cookieconsent/dist/cookieconsent.css';
import '../styles/reset.css';
import '../styles/loader.css';
import '../styles/index.css';
import '../styles/no-js.css';
import '../styles/portfolio.css';
import '../styles/footer.css';
import '../styles/business-card.css';
import '../styles/consent.css';

import initDom from './dom';
import initAnimations from './animations';
import fetchData from './contentful';
import {
  scrollToTop,
  onError,
  useDarkMode,
  setDarkModeMessage,
  debounce,
} from './utils';
import {
  resolveLocale,
  getLanguageCode,
  localizeUrl,
  nextLocale,
} from './locale';
import { LOCALES } from './constants';
import initConsent from './consent';

const init = () => {
  const { locale, redirectTo } = resolveLocale();
  if (redirectTo) {
    window.location.replace(redirectTo);
    return new Promise(() => {}); // halt chain during redirect
  }

  document.documentElement.lang = getLanguageCode(locale);

  return fetchData({ locale }, { excludeLegalContent: true })
    .then(initDom)
    .then(initAnimations)
    .then((config) => {
      const reinitDom = () => {
        initDom(config);
        initAnimations(config);
      };

      setDarkModeMessage();

      document
        .querySelector('button.inverter')
        .addEventListener('click', () => {
          scrollToTop();
          document.documentElement.classList.toggle('dark-mode');
          setDarkModeMessage();
          reinitDom();
        });

      if (LOCALES.length > 1) {
        const languageButton = document.querySelector('button.language');
        languageButton.classList.add('block');
        const target = nextLocale(locale);
        const message =
          getLanguageCode(locale) === 'de'
            ? `Zur englischen Version wechseln`
            : `Switch to the German version`;
        languageButton.setAttribute('aria-label', message);
        languageButton.setAttribute('title', message);
        languageButton.addEventListener('click', () => {
          window.location.replace(
            localizeUrl(window.location.href, locale, target)
          );
        });
      }

      // Scroll scenes bake the viewport size in. Touch browsers fire resize
      // whenever the URL bar collapses (a height change of roughly a tenth),
      // which is not worth a rebuild; on other devices any size change is.
      // Never more than a few times a second either way.
      const coarsePointer =
        !!window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      let lastWidth = window.innerWidth;
      let lastHeight = window.innerHeight;
      const onResize = debounce(() => {
        const { innerWidth, innerHeight } = window;
        const heightDelta = Math.abs(innerHeight - lastHeight) / lastHeight;
        const ignorable = coarsePointer ? heightDelta < 0.2 : heightDelta === 0;
        if (innerWidth === lastWidth && ignorable) return;
        lastWidth = innerWidth;
        lastHeight = innerHeight;
        reinitDom();
      }, 250);
      window.addEventListener('resize', onResize);
      window.addEventListener('orientationchange', onResize);
      if (window.matchMedia) {
        window
          .matchMedia('(prefers-reduced-motion: reduce)')
          .addEventListener('change', reinitDom);
      }

      document.querySelector('div.loading-screen').classList.add('hidden');
      document.documentElement.classList.remove('no-js');

      initConsent(getLanguageCode(locale));
    });
};

try {
  useDarkMode();
  init().catch(onError);
} catch (error) {
  onError(error);
}
